import { createEffect, sample } from 'effector';
import { GetSavedAddressesResponse } from '../api/GetSavedAddressesResponse';
import { savedAddressesApi } from '../api/savedAddressesApi';
import { $savedAddresses } from '../stores';

export const getSavedAddressesFx = createEffect<
  void,
  GetSavedAddressesResponse
>(() => savedAddressesApi.getSavedAddresses());

sample({
  clock: getSavedAddressesFx.doneData,
  fn: (res) => res.items,
  target: $savedAddresses,
});
